import { render, staticRenderFns } from "./ProjectModalSettings.vue?vue&type=template&id=a480b41e&scoped=true&"
import script from "./ProjectModalSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectModalSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModalSettings.vue?vue&type=style&index=0&id=a480b41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a480b41e",
  null
  
)

export default component.exports